<template>

      <el-dialog
            title="批量导入"
            :visible="true"
            width="50%"
            :append-to-body=true
            :before-upload='beforeUpload'
            :before-close="handleClose">
            <div class='import'>
                   <el-upload
            class="upload-demo"
            action="/"
            :on-change="handleChange"
            :auto-upload='false'
            :file-list="fileList"
            >
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">（一次最多可导入100条）</div>
            </el-upload>
            <p>模板下载:</p>
            <div class="tips">
                
                <a href="javascript:;" download> 通用商品批量导入模板下载.xls</a>
            </div>
            <p>注:</p>
            <p>
                1.商品编号、商品名称、是否赠品、经销商级别编号、经销商级别为必填项，其他选填，但商品价格至少填写一个
            </p>
            <p>2.如果填写的是赠品，无需再填写商品属性</p>
            <p>
                3.如果导入的商品与已经上架的商品重复，则会更新已上架的商品
            </p>
            <el-button size="small" type="primary">上传</el-button>
            <el-button size="small" type="primary" @click='reset'>重置</el-button>

            </div>
      </el-dialog>
</template>

<script>
export default {
    data(){
        return{
            fileList:[]
        }
    },
    methods:{
        init(){
            this.$get('logistics','/product.putaways.template').then(res=>{
                this.downLink=res.data
            })
        },
        handleClose(){
            this.$emit('handleClose')
        },
        reset(){
            this.fileList=[]
        },
        handleChange(value,valueList){
            console.log(value,valueList)
            if(valueList.length>1){
                valueList.splice(0,1)
            }
            this.fileList=valueList
        },
        beforeUpload(value){
            console.log(value)
        }
    }
}
</script>
<style lang="scss" scoped>
.import{
    line-height: 22px;
    .tips{

        a{
        color: #f04635

        }
    }
    p{
        margin-bottom: 10px;
    }
}

</style>


